import { render, staticRenderFns } from "./Tema5.vue?vue&type=template&id=b27814ae&scoped=true&lang=pug&"
import script from "./Tema5.vue?vue&type=script&lang=js&"
export * from "./Tema5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27814ae",
  null
  
)

export default component.exports